import React, { useState, useEffect,useRef } from 'react';
import styles from './ModeratorBoxModeratorView.module.css';
import avatar from './../../../assets/default-avatar.svg';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { formatDate, formatRelativeTime } from './../../../utils/dateHelpers/dateHelpers';
import { HiArrowRight } from "react-icons/hi2";
import { collection, query, orderBy, onSnapshot, addDoc, serverTimestamp } from 'firebase/firestore';
import { useAuth } from "../../../utils/AuthContext/authcontext";
import RulesTab from './../Rules/RulesTab';
import Button from '../../ui/Button';
//import TurnTimeline from './../TurnTimeline/TurnTimeline';


const ModeratorBoxModeratorView = ({capabilities, role, isSingleTeam, currentUserteam, isModerator, currentUserData, currentUser, arenaId, arena, moderator, teams, debaters, handleStopRound, handleEndRound,handleAddScore, handleSwitchTurn, handleEndTurn }) => {
   const [activeTab, setActiveTab] = useState('Messages');
    const [text, setText] = useState('');
	const [target, setTarget] = useState('all');
	const [mods, setMods] = useState([]);
	const [modus, setModus] = useState([]);
	const [getModerator, setModerator] = useState(moderator);
    const { searchbyUsersId } = useAuth();
	const currentTurnIndex = arena.currentTurn ?? 0;
  
	useEffect(() => {
	  const startRound = async () => {
		if(mods.length > 0) {
			let debt = await Promise.all(mods.map(async (msg) => {
				if(msg?.target != undefined && msg?.target != "all" && msg?.target.includes("team:") == false) {
					const users = await searchbyUsersId(msg?.target);
					if(users != undefined && users.length > 0) {
						msg.username = users[0].username;
						msg.profilePicture = users[0].profilePicture;
					}
				}
				else
				{
					msg.username = msg?.target;
					msg.profilePicture = msg?.profilePicture;
				}
				return msg;
			}))

			setModus(debt);
		}
	  };
	  startRound();
	}, [mods]);

  const enrichMessagesWithUser = async (mod) =>  {
	const cache = {};
		if (!cache[mod.uid]) {
			cache[mod.uid] = await searchbyUsersId(mod.uid);
			mod.profilePicture = cache[mod.uid]?.[0]?.profilePicture;
			mod.username = cache[mod.uid]?.[0]?.username;
		}
		return mod
	}

	useEffect(() => {
	const process = async () => {
		if (!moderator) return;
		const enriched = await enrichMessagesWithUser(moderator);
		setModerator(enriched);
	};

	process();
	}, [moderator]);

  
	useEffect(() => {
	const q = query(
	  collection(firestore, 'arenas', arenaId, 'moderatormessages'), orderBy('createdAt', 'desc')
	);
	const unsubscribe = onSnapshot(q, snapshot => {
	  setMods(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
	});
	return () => unsubscribe();
	}, [arenaId]);
	
	async function sendMessage() {
	  if (!text.trim()) return;
	  await addDoc(collection(firestore, 'arenas', arenaId, 'moderatormessages'), {
		senderUid: currentUser.uid,
		senderName: currentUserData.username,
		content: text,
		target,
		round: arena.currentRound,
		createdAt: serverTimestamp(),
	  });
	  setText('');
	}
	
// Capitalize first letter utility
function capitalizeFirst(str) {
	if (!str) return '';
	return str.charAt(0).toUpperCase() + str.slice(1);
}

return (
	<div className={`${isSingleTeam == true ? styles.boxsingle : styles.box}`} > 
		<div className={`${isSingleTeam == true ? styles.moderatorBoxSingle : styles.moderatorBox}`}>
			<div className={currentUser?.uid === getModerator?.uid ? `${styles.header} ${styles.you}` : styles.header}>
				<img src={getModerator?.profilePicture || avatar} alt="Moderator" />
				<div>
					<div className={styles.name}>{getModerator?.username || currentUserData?.username}</div>
					<div className={styles.role}>{capitalizeFirst(role)}</div>
				</div>
			</div>

			<div className={styles.tabs}>
				{['Messages', 'Rules', 'Controls'].map(tab => (
					<Button
						key={tab}
						variant={activeTab === tab ? 'primary' : 'ghost'}
						className={activeTab === tab ? styles.activeTab : ''}
						onClick={() => setActiveTab(tab)}>
						{capitalizeFirst(tab)}
					</Button>
				))}
			</div>

			<div className={styles.content}>
				{activeTab === 'Messages' && (
					<>
						{/*<div className={styles.timeline}><TurnTimeline formatId={arena.formatId} currentTurnId={'CG'} /></div>*/}
							<div className={styles.messagePanel}>
								<h3 className={styles.title}>{capitalizeFirst('Messages')}</h3>
								{modus.map(m => (
									<div key={m.id} className={styles.modMessage}>
										<div className={styles.modMeta}>
											<div className={styles.modname}>{m.senderName} {m.target !== 'all' && m.target !== undefined ? <span> <HiArrowRight />  {m.username}</span> : <></>}</div>
											<span className={styles.modTime} title={formatDate(m.createdAt)}>
												{formatRelativeTime(m.createdAt)}
											</span>
										</div>
										<div className={styles.modContent}>{m.content}</div>
									</div>
								))}
							</div>
						<div className={styles.messageInput}>
							<select className={styles.threadSelect} value={target} onChange={e => setTarget(e.target.value)}>
								<option value="all">{capitalizeFirst('Everyone')}</option>
								{teams.map(team => <option key={team} value={`team: ${team}`}>{capitalizeFirst(team)}</option>)}
								{debaters.filter(d => d?.username != undefined).map(u => <option key={u.uid} value={u.uid}>{capitalizeFirst(u.username)}</option>)}
							</select>
							<textarea value={text} onChange={e => setText(e.target.value)} />
							<Button variant="primary" className={styles.sendButton} onClick={sendMessage}>{capitalizeFirst('Send')}</Button>
						</div>
					</>
				)}

				{activeTab === 'Rules' && (
					<div className={styles.rulesSection}>
						<RulesTab formatId={arena.formatId} isModerator={isModerator} arenaId={arenaId} />
					</div>
				)}

				{activeTab === 'Controls' && (
					<div className={styles.controlsPanel}>
					{/*<Button variant="secondary" className={styles.controlButton} onClick={handleStopRound}>{capitalizeFirst('Stop Round')}</Button>
					<Button variant="secondary" className={styles.controlButton} onClick={handleEndRound}>{capitalizeFirst('End Round')}</Button>
					<Button variant="secondary" className={styles.controlButton} onClick={handleAddScore}>{capitalizeFirst('Add Score')}</Button>
					<Button variant="secondary" className={styles.controlButton} onClick={handleSwitchTurn}>{capitalizeFirst('Switch Turn')}</Button>*/}
					{capabilities.canEndTurn === true && (
						<Button variant="secondary" className={styles.controlButton} onClick={handleEndTurn}>{capitalizeFirst('End Turn')}</Button>
					)}
					</div>
				)}
			</div>
		</div>
	</div>
);
};

export default ModeratorBoxModeratorView;
